import { PolicyList } from '@/features/policies/components/PolicyList'
import s from '@/shared/styles/policyTabs.module.css'
import { type PolicyScope } from '@/features/policies/tabs/policyScopes'

// ── One artefact tab: its enablement state + its own policy list ──────────────
export function ArtefactPanel({ orgId, canAdmin, isOwner, artefact }: {
  orgId: string; canAdmin: boolean; isOwner: boolean; artefact: PolicyScope
}) {
  return (
    <div style={{ display: 'grid', gap: 14 }}>
      {!artefact.live && (
        <div className={s.tierBanner}>
          {artefact.label} policy enforcement is configured here but not yet gating — verdicts land once the {artefact.label.toLowerCase()} scanner ships. Policies you author now will apply automatically when it does.
        </div>
      )}
      <PolicyList orgId={orgId} canAdmin={canAdmin} isOwner={isOwner} artefactType={artefact.key} />
    </div>
  )
}
